<style lang="scss" scoped>
.calendar-wrapper{
  width: 960px;
  margin: 0 auto;
  margin-top: 14px;
  overflow: hidden;
  &-top{
   width: 100%;
   height: 232px;
   background: url('./../assets/img/group32.svg') no-repeat;
   background-size: contain;
   position: relative;
   z-index: 1;
   overflow: hidden;
   &-title{
     margin-top: 77px;
     font-size:30px;
     font-family:PingFangSC-Semibold;
     font-weight:600;
     color:rgba(255,255,255,1);
     line-height:41px;
   }
  }
  &-content{
    width: 100%;
    // height: 1300px;
    background:rgba(26,88,181,1);
    border-radius:31px;
    margin-top: -82px;
    padding-top: 5px;
    position: relative;
    z-index: 0;
    ul{
      display: flex;
      justify-content: left;
      flex-wrap: wrap;
      padding: 0 18px 80px 18px;
      li{
        margin: 200px 0 0 66px;
        position: relative;
        &::before{
          content: '';
          width: 132px;
          height: 78px;
          background: url('./../assets/img/yijia.svg') no-repeat;
          background-size: contain;
          position: absolute;
          left: 50%;
          transform: translate(-50%);
          top: -28%;
        }
        .rili-wrapper{
          &-content{
            width: 220px;
            position: relative;
            &-date{
              // width:91px;
              white-space: nowrap;
              height:33px;
              font-size:24px;
              font-family:PingFangSC-Medium;
              font-weight:500;
              color:rgba(255,255,255,1);
              line-height:33px;
              position: absolute;
              left: 50%;
              transform: translate(-50%);
              top: -116px;
            }
            &-top{
              width:220px;
              height:185px;
              background:rgba(255,255,255,1);
              border-radius:16px 16px 0px 0px;
              overflow: hidden;
              img{
                width: 100%;
                height: 100%;
              }
            }
            &-bottom-open{
              width:220px;
              height:60px;
              background:rgba(253,196,13,1);
              border-radius:0px 0px 16px 16px;
              span{
                width: 100%;
                height: 100%;
                display: block;
                font-size:20px;
                font-family:PingFangSC-Medium;
                font-weight:500;
                color:#45484D;
                line-height:60px;
                cursor: pointer;
              }
            }
            &-bottom-wait{
              width:220px;
              height:60px;
              background:#297FFF;
              border-radius:0px 0px 16px 16px;
              p{
                font-size:20px;
                font-family:PingFangSC-Medium;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:60px;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="calendar-wrapper">
    <div class="calendar-wrapper-top">
      <div class="calendar-wrapper-top-title">
        <p v-if="lotteryCalendarData">{{lotteryCalendarData.title}}</p>
      </div>
    </div>
    <div class="calendar-wrapper-content">
      <ul v-if="lotteryCalendarData">
        <li v-for="(item, index) in lotteryCalendarData.itemList">
          <div class="rili-wrapper">
            <div class="rili-wrapper-content">
              <p class="rili-wrapper-content-date">{{item.title}}</p>
              <div class="rili-wrapper-content-top">
                <img :src="item.cover" alt="">
              </div>
              <div class="rili-wrapper-content-bottom-open" v-if="item.link">
                <span @click="statisticsLink(item.link, index)" >{{item.desc}}</span>
              </div>
              <div class="rili-wrapper-content-bottom-wait" v-else>
                <p>{{item.desc}}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: true,
      lotteryCalendarData: {},
    }
  },
  methods: {
    statisticsLink(link, index) {
      this.$http.statItemClick({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_share_list'+(index+1)+'_click'}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}}).then((res) => {
        window.open(link);
      });
    }
  },
  mounted() {
    this.$bus.on('lotteryCalendarData', (data) => {
      this.lotteryCalendarData = data;
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LotteryCalendar.vue